<div
  class="modal-overlay"
  [class.is-open]="!!config"
  (click)="close()"
  role="presentation"
>
  <div
    class="modal-container"
    [class.is-dragging]="isDragging"
    [class.is-wide]="isWide"
    [style.transform]="dragTransform"
    (click)="$event.stopPropagation()"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="config ? 'modal-title' : null"
  >
    <div
      class="modal-header"
      (pointerdown)="onHeaderPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerCancel($event)"
    >
      <div class="modal-sheet-handle" aria-hidden="true"></div>

      <h3 class="modal-title" id="modal-title">{{ config?.title }}</h3>

      <button
        type="button"
        class="close-btn"
        (click)="close()"
        (pointerdown)="$event.stopPropagation()"
        aria-label="Закрыть"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <ng-container #modalContent></ng-container>
    </div>
  </div>
</div>
